{
  "c2j-confluence-side-nav.active-team.body": [
    {
      "type": 0,
      "value": "See what your team is planning and tracking in Jira."
    }
  ],
  "c2j-confluence-side-nav.active-team.cta": [
    {
      "type": 0,
      "value": "Open Jira project"
    }
  ],
  "c2j-confluence-side-nav.active-team.title": [
    {
      "type": 0,
      "value": "Your teammates are working in Jira"
    }
  ],
  "c2j-confluence-side-nav.assigned-work.body": [
    {
      "type": 0,
      "value": "Catch up on the Jira work assigned to you."
    }
  ],
  "c2j-confluence-side-nav.assigned-work.cta": [
    {
      "type": 0,
      "value": "View your work"
    }
  ],
  "c2j-confluence-side-nav.assigned-work.title": [
    {
      "type": 0,
      "value": "You have work waiting in Jira"
    }
  ],
  "c2j-confluence-side-nav.close": [
    {
      "type": 0,
      "value": "Dismiss recommendation"
    }
  ],
  "c2j-confluence-side-nav.why.body": [
    {
      "type": 0,
      "value": "This recommendation is based on Jira work relevant to you and your team."
    }
  ],
  "c2j-confluence-side-nav.why.title": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "jira-coding-agent-recommendation.choose-space": [
    {
      "type": 0,
      "value": "Choose a space"
    }
  ],
  "jira-coding-agent-recommendation.description": [
    {
      "type": 0,
      "value": "Jira Coding Agent can review PRs attached to work to flag errors and suggest changes."
    }
  ],
  "jira-coding-agent-recommendation.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-coding-agent-recommendation.set-up-in": [
    {
      "type": 0,
      "value": "Set up in "
    },
    {
      "type": 1,
      "value": "projectName"
    }
  ],
  "jira-coding-agent-recommendation.title": [
    {
      "type": 0,
      "value": "Write code and review PRs automatically"
    }
  ],
  "jira-crossflow-recommendation-confluence.banner-button": [
    {
      "type": 0,
      "value": "Try it"
    }
  ],
  "jira-crossflow-recommendation-confluence.banner-description": [
    {
      "type": 0,
      "value": "With Confluence, you can write docs that are connected to your work in Jira, so work stays in sync."
    }
  ],
  "jira-crossflow-recommendation-confluence.banner-dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-crossflow-recommendation-confluence.banner-title": [
    {
      "type": 0,
      "value": "Create and organize docs, all in one place"
    }
  ],
  "jira-crossflow-recommendation-jpd.banner-button": [
    {
      "type": 0,
      "value": "Try it"
    }
  ],
  "jira-crossflow-recommendation-jpd.banner-description": [
    {
      "type": 0,
      "value": "Try Jira Product Discovery to explore, discuss, and prioritize ideas—then move the best ones straight into Jira."
    }
  ],
  "jira-crossflow-recommendation-jpd.banner-dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-crossflow-recommendation-jpd.banner-title": [
    {
      "type": 0,
      "value": "Revitalize your roadmap"
    }
  ],
  "jira-crossflow-recommendation-jsm-operations.banner-button": [
    {
      "type": 0,
      "value": "Let's start"
    }
  ],
  "jira-crossflow-recommendation-jsm-operations.banner-description": [
    {
      "type": 0,
      "value": "Create on-call schedules and track alerts to resolve incidents faster. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Read more about operations"
        }
      ],
      "type": 8,
      "value": "link"
    }
  ],
  "jira-crossflow-recommendation-jsm-operations.banner-dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-crossflow-recommendation-jsm-operations.banner-title": [
    {
      "type": 0,
      "value": "Supercharge your IT teams with operations"
    }
  ],
  "jira-crossflow-recommendation-jsm.banner-button": [
    {
      "type": 0,
      "value": "Try it"
    }
  ],
  "jira-crossflow-recommendation-jsm.banner-description": [
    {
      "type": 0,
      "value": "When you use Jira and Jira Service Management together, you can track and resolve requests in one place."
    }
  ],
  "jira-crossflow-recommendation-jsm.banner-dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-crossflow-recommendation-jsm.banner-title": [
    {
      "type": 0,
      "value": "Track and resolve support issues, fast"
    }
  ],
  "jira-space-dashboard-guide.dismiss-button.nonfinal": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-space-dashboard-guide.next-button.nonfinal": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-space-dashboard-guide.step-counter.nonfinal": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "jira-space-dashboard-guide.step1-content.nonfinal": [
    {
      "type": 0,
      "value": "Your existing reports haven’t gone anywhere. Find them easily and switch back anytime."
    }
  ],
  "jira-space-dashboard-guide.step1-title.nonfinal": [
    {
      "type": 0,
      "value": "Classic reports are still here"
    }
  ],
  "jira-space-dashboard-guide.step2-content.nonfinal": [
    {
      "type": 0,
      "value": "Tailor your reporting, adding widgets and rearranging elements to create a personalized view of what matters most in your space."
    }
  ],
  "jira-space-dashboard-guide.step2-title.nonfinal": [
    {
      "type": 0,
      "value": "New customizable dashboard"
    }
  ],
  "jira-triage-agent-recommendation.choose-space": [
    {
      "type": 0,
      "value": "Choose a space"
    }
  ],
  "jira-triage-agent-recommendation.description": [
    {
      "type": 0,
      "value": "Jira Triage Agent reviews incoming work to flag duplicates and suggest fields like assignee, priority and labels, as soon as they land. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "See how it works."
        }
      ],
      "type": 8,
      "value": "learnMore"
    }
  ],
  "jira-triage-agent-recommendation.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-triage-agent-recommendation.set-up-in": [
    {
      "type": 0,
      "value": "Set up in "
    },
    {
      "type": 1,
      "value": "projectName"
    }
  ],
  "jira-triage-agent-recommendation.title": [
    {
      "type": 0,
      "value": "Triage new work automatically"
    }
  ]
}